'use client';
import React from 'react';
import { RoundedSectionCard } from '../common/RoundedSectionCard';

interface AlphabetSectionProps {
  activeLetters: string[];
}

const AlphabetSection: React.FC<AlphabetSectionProps> = ({ activeLetters }) => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const handleLetterClick = (letter: string) => {
    const targetElement = document.getElementById(`section-${letter}`);
    if (targetElement) {
      const headerOffset = 100;
      const topPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerOffset;

      window.scrollTo({
        top: topPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <RoundedSectionCard>
      <div className="flex flex-wrap justify-center gap-2">
        {alphabet.map((letter) => {
          const isActive = activeLetters.includes(letter);
          return (
            <button
              key={letter}
              onClick={() => isActive && handleLetterClick(letter)}
              disabled={!isActive}
              className={`rounded px-2 py-1 text-2xl font-bold  ${isActive ? 'hover:underline' : 'cursor-not-allowed text-info-content'}`}
            >
              {letter}
            </button>
          );
        })}
      </div>
    </RoundedSectionCard>
  );
};

export default AlphabetSection;
